<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm"><a class="xref" href="#/uma_Bane0008#acknow">Acknowledgments ix</a></p>
<p class="tocf"><a class="xref" href="#/uma_Bane0010#prog">Prologue: Do the Dead Choose Their Biographers?</a></p>
<p class="toc"><a class="xref" href="#/uma_Bane0011#ch01">1  The Search for Companionship</a></p>
<p class="toc"><a class="xref" href="#/uma_Bane0012#ch02">2 “Between the Old and the New”</a></p>
<p class="toc"><span class="xref" href="#/uma_Bane0013#ch03" title="Link target outside of Sample">3 Falling in Love: The Exuberant Years</span></p>
<p class="toc"><span class="xref" href="#/uma_Bane0014#ch04" title="Link target outside of Sample">4 A Star Is Born</span></p>
<p class="toc"><span class="xref" href="#/uma_Bane0015#ch05" title="Link target outside of Sample">5 Making a Home in Kittery</span></p>
<p class="toc"><span class="xref" href="#/uma_Bane0016#ch06" title="Link target outside of Sample">6 Shining in a Dark Time: Politics and Painting in the Depression</span></p>
<p class="toc"><span class="xref" href="#/uma_Bane0017#ch07" title="Link target outside of Sample">7 In Sickness and in Health: The Hartford Retreat, McLean Hospital, and Baldpate Hospital</span></p>
<p class="toc"><span class="xref" href="#/uma_Bane0018#ch08" title="Link target outside of Sample">8 The Green Light across the Piscataqua</span></p>
<p class="toc"><span class="xref" href="#/uma_Bane0019#ch09" title="Link target outside of Sample">9 Losing Touch: Life without Cheney</span></p>
<p class="toc"><span class="xref" href="#/uma_Bane0020#ch10" title="Link target outside of Sample">10 Aftermath and Afterglow</span></p>
<p class="toc"><span class="xref" href="#/uma_Bane0021#epil" title="Link target outside of Sample">Epilogue: Getting Married After All</span></p>
<p class="tocbmf"><span class="xref" href="#/uma_Bane0022#notes" title="Link target outside of Sample">Notes</span></p>
<p class="tocbm"><span class="xref" href="#/uma_Bane0024#index" title="Link target outside of Sample">Index</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma_Bane0007.vue?05588986